import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  container: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: 'white',
    padding: '1rem',
    borderRadius: '0.75rem',
    textAlign: 'center',
  },
}));
